import { render, staticRenderFns } from "./QuestionModels.vue?vue&type=template&id=447c1baa&scoped=true&"
import script from "./QuestionModels.vue?vue&type=script&lang=js&"
export * from "./QuestionModels.vue?vue&type=script&lang=js&"
import style0 from "./QuestionModels.vue?vue&type=style&index=0&id=447c1baa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447c1baa",
  null
  
)

export default component.exports